import React from 'react';
import { useTranslation } from 'react-i18next';

import ChevronDownIcon from '../../resources/assets/icons/ChevronDownIcon';
import ChevronUpIcon from '../../resources/assets/icons/ChevronUpIcon';
import MenuManager from '../../services/api/MenuManager';
import { useHelpers } from '../../providers/HelpersProvider';
import { Card, Switch, Table } from 'antd';

export default function CategoryCard({ category, isCollapsed, toggle, onProductChange }) {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Cards:CategoryCard' });

  const { formatCurrency } = useHelpers();

  const toggleProductAvailable = (product) => {
    MenuManager.updateProduct(product.id, {
      is_available: !product.is_available,
    }).then(() => onProductChange());
  };

  return (
    <Card classNames={{ body: '!p-none' }}>
      <div className="p-md flex justify-between gap-md">
        <div className="flex justify-center py-3">
          <h4 className="my-auto text-black mr-4">{category.name}</h4>
          <div className="text-white bg-primary justify-center items-center rounded-sm px-2 my-auto">
            {category.products.length}
          </div>
        </div>
        <div className="py-3 text-black cursor-pointer flex justify-center" onClick={toggle}>
          <p className="mx-2 my-auto">{isCollapsed ? t('labels.open') : t('labels.collapse')}</p>
          {isCollapsed ? <ChevronDownIcon color="#000000" /> : <ChevronUpIcon color="#000000" />}
        </div>
      </div>
      {!isCollapsed && (
        <div className="w-full overflow-x-auto">
          <Table
            className="bg-white"
            pagination={false}
            rowKey={(item) => `product-${category.id}-${item.id}`}
            dataSource={category.products}
            columns={[
              {
                key: 'is_available',
                title: t('list.is_available'),
                render: (item) => (
                  <div className="flex flex-col">
                    <Switch
                      id={`product-${item.id}-is-available`}
                      checked={item.is_available}
                      onChange={() => toggleProductAvailable(item)}
                      className="w-fit"
                    />
                    <label htmlFor={`product-${item.id}-is-available`} className="mt-xs">
                      {item.is_available ? t('labels.in_stock') : t('labels.out_of_stock')}
                    </label>
                  </div>
                ),
              },
              {
                key: 'name',
                title: t('list.name'),
                dataIndex: 'name',
              },
              {
                key: 'price',
                title: t('list.price'),
                render: (item) => formatCurrency(item.price),
              },
            ]}
          />
        </div>
      )}
    </Card>
  );
}
